module.exports = __webpack_public_path__ + "static-wf/img/img-in-dialog-bg.1f2eaa4.jpg";